import { useGetDocument } from 'pages/documents_v2/hooks/useGetDocument';

const emptyArray = [];

/**
 * @param {number} [documentId]
 * @param {boolean} [showAreas]
 * @returns {import('models/documents.models').Section[]}
 */
export function useGetSections(documentId = undefined, showAreas = false) {
    const document = useGetDocument(documentId, showAreas);

    return document?.sections ?? emptyArray;
}
